import MessageGenerator from '@/lib/messageGenerator'
import searchAdjectives from '../json/searchAdjectives.json'
import liberalReplaceAdjectives from '../json/replaceAdjectives/liberal.json'
import nerReplaceAdjectives from '../json/replaceAdjectives/ner.json'
import genderReplaceAdjectives from '../json/replaceAdjectives/gender.json'
import genderOutputSentences from '../json/outputSentences/gender.json'
import liberalOutputSentences from '../json/outputSentences/liberal.json'
import commonOutputSentences from '../json/outputSentences/common.json'

import nerOutputSentences from '../json/outputSentences/ner.json'

import NameGenerator from '@/lib/nameGenerator'
import nameSelection from '@/json/randomNames'

const liberal = MessageGenerator({
  adjectives: {
    searchValues: searchAdjectives,
    replaceValues: liberalReplaceAdjectives
  },
  outputSentences: [...commonOutputSentences, ...liberalOutputSentences]
});

const gender = MessageGenerator({
  adjectives: {
    searchValues: searchAdjectives,
    replaceValues: genderReplaceAdjectives
  },
  outputSentences: [...commonOutputSentences, ...genderOutputSentences]
});

const NERify = MessageGenerator({
  adjectives: {
    searchValues: searchAdjectives,
    replaceValues: nerReplaceAdjectives
  },
  outputSentences: [...commonOutputSentences, ...nerOutputSentences]
});

const asIs = (text) => text;

const generateName = NameGenerator(nameSelection);

export {
  gender,
  liberal,
  NERify,
  asIs,
  generateName
}

// Site stuff

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.navbar-toggler').addEventListener('click', () => {
    document.querySelector('.navbar-collapse').classList.toggle('show');
  })
});
